import React, { useEffect, useMemo, useState } from 'react';
import { sharedTableStyles } from '../../../utils/tableStyles';
import { TableSkeleton } from '../../../components/UI/Skeleton/Skeleton';
import RowActionMenu from '../../../components/UI/RowActionMenu/RowActionMenu';
import TableCard from '../../../components/UI/TableToolbar/TableCard';
import TableToolbar from '../../../components/UI/TableToolbar/TableToolbar';
import DataTable from 'react-data-table-component';

import PageHeader from '../../../components/common/PageHeader';
import { useGetSystemRoleQuery } from '../../../redux/apis/systemRoleApi';
import EmptyData from '../../../components/UI/EmptyData';
import { ROLES } from '../../../utils/constant/global';
import { useNavigate } from 'react-router-dom';

import './system-role-details.css';

const systemRoleTableStyles = {
  ...sharedTableStyles,
  headCells: {
    style: {
      ...sharedTableStyles.headCells.style,
      color: '#334155',
      fontWeight: 700
    }
  },
  rows: {
    ...sharedTableStyles.rows,
    style: {
      ...sharedTableStyles.rows.style,
      color: '#6b7280'
    }
  },
  cells: {
    style: {
      ...sharedTableStyles.cells.style,
      color: '#6b7280',
      fontWeight: 600
    }
  }
};

const SystemRoleList = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const { data, isLoading, isFetching, refetch: refetchSystemRoles } = useGetSystemRoleQuery();

  useEffect(() => {
    refetchSystemRoles();
  }, []);
  // 🔹 Map API response → table format
  const roles = useMemo(() => {
    if (!data?.data) return [];

    return data.data
      .filter((item) => item.roleName !== ROLES.ADMIN)
      .map((item) => ({
        id: item._id,
        name: item.roleName,

        status: item.isActive ? 'Active' : 'Inactive',
        raw: item
      }));
  }, [data]);

  // 🔹 Search filter
  const filteredData = useMemo(() => {
    return roles.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));
  }, [roles, search]);

  // 🔹 Table columns
  const columns = useMemo(
    () => [
      {
        name: 'Role Name',
        selector: (row) => row.name,
        sortable: true,
        grow: 2,
        cell: (row) => <span className="system-role-name">{row.name || '—'}</span>
      },
      {
        name: 'Status',
        cell: (row) => (
          <span
            className={`role-status-badge ${row.status === 'Active' ? 'role-status-badge--active' : 'role-status-badge--inactive'}`}
          >
            <span className="role-status-badge__dot" aria-hidden />
            {row.status}
          </span>
        )
      },
      {
        name: 'Actions',
        cell: (row) => (
          <RowActionMenu
            actions={[
              {
                label: 'Edit permissions',
                icon: 'icofont-edit',
                variant: 'success',
                onClick: () => navigate(`/system-roles/${row.id}`)
              }
            ]}
          />
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true
      }
    ],
    []
  );

  return (
    <>
      <PageHeader headerTitle="System Roles" />

      <div className="container-xxl">
        <div className="row clearfix g-3">
          <div className="col-sm-12">
            <TableCard>
              <TableToolbar searchPlaceholder="Search role..." onSearch={(val) => setSearch(val)} />
              <div className="card-body">
                <div className="system-role-table">
                  <DataTable
                    customStyles={systemRoleTableStyles}
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    striped
                    responsive
                    noDataComponent={<EmptyData />}
                    progressPending={isLoading || isFetching}
                    progressComponent={<TableSkeleton columns={3} />}
                  />
                </div>
              </div>
            </TableCard>
          </div>
        </div>
      </div>
    </>
  );
};

export default SystemRoleList;
